/* eslint-disable no-unused-vars */
import { forwardRef, useId, useEffect } from 'react';
import { Label, CustomInput, Buttons, Loader } from 'components';
import { DeleteIcon } from 'assets/icons';
import { useSignal, useComputed } from '@preact/signals-react';
import { manageAppsAPI } from 'services/manageApps.service';
import { showPolipop } from 'utils';

export const FixUrlTooltip = forwardRef((props, ref) => {
  const inputId = useId();
  const storeURL$ = useSignal('');
  const wrongUrl$ = useSignal(false);
  const errorFlag$ = useSignal(false);
  const [saveUrlAction, result] = manageAppsAPI.useFixAppUrlMutation();

  useEffect(() => {
    props.showLoader$.value = result.isLoading;
  }, [result.isLoading]);

  const handleSave = async () => {
    const res = await saveUrlAction({ store_url: storeURL$.value, pba_id: props.pba_id });
    if (res?.data?.status) {
      props.setIsOpen(false);
    }
    if ('error' in res) {
      errorFlag$.value = true;
      wrongUrl$.value = true;
    }
  };

  const successAction = () => {
    console.log('successAction');
  };

  const errorAction = () => {
    console.log('errorAction');
  };

  useEffect(() => {
    showPolipop(result, successAction, errorAction);
  }, [result]);

  const showErrorMsg$ = useComputed(() => {
    if (!storeURL$.value) return 'This field is required';
    if (wrongUrl$.value) return 'The URL you have entered is invalid';
  });

  return (
    <div ref={ref} style={{ padding: '16px' }}>
      <Label text='Store Listing URL:' variant='label' style={{ marginBottom: '8px' }} />
      <CustomInput
        onChange={(e) => {
          if (!e.target.value) {
            errorFlag$.value = true;
          } else {
            errorFlag$.value = false;
          }
          storeURL$.value = e.target.value;
        }}
        id={inputId}
        name={inputId}
        value={storeURL$.value}
        width={377}
        rightIcon={<DeleteIcon />}
        rightIconOnClick={() => {
          errorFlag$.value = true;
          storeURL$.value = '';
        }}
        autoComplete='off'
        error={errorFlag$.value}
        errorText={showErrorMsg$.value}
      />
      <div
        style={{
          display: 'flex',
          gap: '16px',
          marginTop: '16px',
          justifyContent: 'space-around',
        }}
      >
        <Buttons.SecondaryNormal
          id='close-storeUrl-tooltip'
          style={{ width: '100%' }}
          onClick={() => props.setIsOpen(false)}
        >
          Cancel
        </Buttons.SecondaryNormal>
        <Buttons.PrimaryNormal
          id='save-storeUrl-tooltip'
          style={{ width: '100%' }}
          onClick={handleSave}
          isDisabled={!storeURL$.value}
        >
          Ok
        </Buttons.PrimaryNormal>
      </div>
    </div>
  );
});

FixUrlTooltip.displayName = 'FixUrlTooltip';
